"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfigContext = void 0;
var react_1 = require("react");
var ConfigContext_1 = __importDefault(require("../../components/LocalizationConfig/ConfigContext"));
exports.useConfigContext = function () { return react_1.useContext(ConfigContext_1.default); };
